<template>
    <footer>
        <div class="text-right">
            <p>
                <span>© {{currentYear}} C2B Software</span>
            </p>
        </div>
    </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'FooterCmp',
    data() {
        return {
            currentYear: new Date().getFullYear(),
        }
    },
}
</script>

<style lang="scss" scoped>
footer {
    display: none;

    @media (min-width: 992px) {
        clear: both;
        float: right;
        display: block;
        font-size: .8em;
        font-family: monospace;
        color: #777;
        padding: 50px 20px 0 0;        
        
        p {
            span {
                &:not(:last-of-type) {
                    margin-right: 15px;
                }

                a {
                    color: #777;
                    text-decoration: none;

                    &:hover {
                        border-bottom: 1px dashed #aaa;
                    }
                }
            }
        }
    }    
}
</style>
